import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("ul", {
    class: "oxd-chart-legend",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (dataPoint, index) => {
      return (_openBlock(), _createElementBlock("li", { key: dataPoint }, [
        (_ctx.labelStyles[index])
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                class: "oxd-chart-legend-key",
                style: _normalizeStyle(_ctx.keyStyles[index])
              }, null, 4),
              _createVNode(_component_oxd_text, {
                tag: "span",
                title: _ctx.labels[index],
                style: _normalizeStyle(_ctx.labelStyles[index]),
                onClick: ($event: any) => (_ctx.onClickKey(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labels[index]), 1)
                ]),
                _: 2
              }, 1032, ["title", "style", "onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}